import * as types from '../actionsTypes/datiRegistroActionType';

//************************************** Inizio Action Timbrature per Mese Singolo Individuo *****************************

// export for testing
export const ricercaTimbratureStartPerRegistroAction = (reqs, tab, page, cognome) => ({
    type: types.RICERCA_TIMBRATURE_START_REGISTRO_ACTION,
    reqs, tab, page, cognome
});

export const ricercaTimbratureStartPerRegistroEnd = (dataRegistry, individuoRegistry, totalCount, errors) => ({
    type: types.RICERCA_TIMBRATURE_START_REGISTRO_END,
    dataRegistry,
    individuoRegistry,
    totalCount,
    errors
});

export const initResocontoMeseReducer = () => ({
    type: types.INIT_RESOCONTO_MESE_REDUCER
});

export const initResocontoMeseAction = () => ({
    type: types.INIT_RESOCONTO_MESE_ACTION
});


//************************************** Fine Action Timbrature per Mese Singolo Individuo *******************************

export const setIndividuiSelezionatiRegistro = (arrayObjInd) => ({
    type: types.SET_INDIVIDUI_SELEZIONATI_REGISTRO,
    arrayObjInd
})
